import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";

export default function LoginPage() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      nav("/");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex" data-testid="login-page">
      <div className="hidden md:block flex-1 relative">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage:
              "url(https://images.pexels.com/photos/28827841/pexels-photo-28827841.jpeg)",
          }}
        />
        <div className="absolute inset-0 bg-black/60" />
        <div className="relative h-full flex flex-col justify-between p-12">
          <div className="font-display text-3xl tracking-[0.3em] text-white">EGNCY</div>
          <div>
            <h1 className="font-display text-5xl lg:text-6xl text-white leading-none uppercase tracking-tight">
              Where footballers <br /> get seen.
            </h1>
            <p className="mt-4 text-[#a3a3a3] max-w-md">
              Highlights, stats, and match reports. Build your player page and follow the players who play like you.
            </p>
          </div>
        </div>
      </div>

      <div className="flex-1 flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-sm space-y-6">
          <div>
            <div className="font-display text-2xl tracking-widest text-white md:hidden mb-8">EGNCY</div>
            <h2 className="font-display text-3xl uppercase tracking-tight text-white">Log in</h2>
            <p className="text-sm text-[#a3a3a3] mt-1">Back to your player page.</p>
          </div>
          {error && (
            <div data-testid="login-error" className="text-sm text-red-400 border border-red-500/40 bg-red-500/10 p-3 rounded-sm">
              {error}
            </div>
          )}
          <div className="space-y-3">
            <input
              data-testid="login-email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Email"
              className="w-full bg-[#0a0a0a] border border-[#262626] focus:border-white outline-none px-4 py-3 rounded-sm text-white transition-colors"
            />
            <input
              data-testid="login-password"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Password"
              className="w-full bg-[#0a0a0a] border border-[#262626] focus:border-white outline-none px-4 py-3 rounded-sm text-white transition-colors"
            />
          </div>
          <button
            data-testid="login-submit"
            type="submit"
            disabled={loading}
            className="w-full bg-white text-black font-semibold py-3 rounded-sm hover:bg-gray-200 disabled:opacity-60 transition-colors"
          >
            {loading ? "Signing in…" : "Sign in"}
          </button>
          <div className="text-sm text-center">
            <Link to="/forgot-password" data-testid="link-forgot-password" className="text-[#a3a3a3] hover:text-white hover:underline">
              Forgot password?
            </Link>
          </div>
          <div className="text-sm text-[#a3a3a3] text-center">
            New here?{" "}
            <Link to="/register" data-testid="link-register" className="text-white hover:underline">
              Create an account
            </Link>
          </div>
        </form>

        <div className="text-xs text-[#525252] text-center mt-6 space-x-3" data-testid="login-legal-links">
          <Link to="/terms" data-testid="login-terms-link" className="hover:text-white hover:underline">Terms</Link>
          <span>&middot;</span>
          <Link to="/privacy" data-testid="login-privacy-link" className="hover:text-white hover:underline">Privacy</Link>
        </div>
      </div>
    </div>
  );
}
